import React, { FC } from 'react';

import { ForgeFctWrapper } from '../components/ForgeFctWrapper/ForgeFctWrapper';
import { ForgeUIExtensionProviderWrapper } from '../components/ForgeUIExtensionProviderWrapper/ForgeUIExtensionProviderWrapper';
import { ForgeExtensionSingleAppProps } from '../types';

export const ForgeExtensionSingleApp: FC<ForgeExtensionSingleAppProps> = ({
  shouldCallGetContextToken = true,
  bridge,
  currentUser,
  entryPoint,
  extension,
  extensionData,
  onInitialRender,
  onTearDown,
  workspace,
}) => (
  <ForgeUIExtensionProviderWrapper
    currentUser={currentUser}
    moduleType={extensionData.type}
    noAccessRenderFallback={undefined} // TODO when adding logic to handle anonymous users
  >
    <ForgeFctWrapper
      bridge={bridge}
      shouldCallGetContextToken={shouldCallGetContextToken}
      currentUser={currentUser}
      entryPoint={entryPoint}
      extensions={[extension]}
      extensionData={extensionData}
      onInitialRender={onInitialRender}
      onTearDown={onTearDown}
      workspace={workspace}
      WrapperComponent={({ children }) => <>{children}</>}
    />
  </ForgeUIExtensionProviderWrapper>
);
